module.exports = __webpack_public_path__ + "static/cover2-e32c53d93352718a24967f6dc5e1294f.png";